import { MarkdownInput } from '@react-admin/ra-markdown';
import { BooleanInput, Create, Datagrid, Edit, List, SimpleForm, TextField, TextInput } from 'react-admin';
import { ColorBooleanField as BooleanField, ColorChipField as ChipField, defaultListFilters } from './customized-elements';

export const TypesList = () => (
    <List filters={ defaultListFilters }>
        <Datagrid rowClick="edit" isRowSelectable={(record) => false}>
            <ChipField source="title" />
            <TextField source="slug" />
            <BooleanField source="status" />
        </Datagrid>
    </List>
)

export const TypesEdit = (props: any) => {
    return (
        <Edit title="Type">
            <SimpleForm>
                <TextInput source="title" fullWidth />
                <TextInput source="slug" fullWidth />
                <TextInput source="icon" fullWidth />
                <TextInput source="header" fullWidth />
                <TextInput source="subHeader" fullWidth />
                <TextInput source="step" fullWidth />
                <TextInput source="stepLabel" fullWidth />
                <MarkdownInput source="tooltipLabel" fullWidth />
                <MarkdownInput source="tooltip" fullWidth />
                <TextInput source="screen" fullWidth />
                <BooleanInput source="status" />
            </SimpleForm>
        </Edit>
    )
}

export const TypesCreate = () => {
    return (
        <Create>
            <SimpleForm>
                <TextInput source="title" fullWidth />
                <TextField source="slug" fullWidth />
                <TextInput source="icon" fullWidth />
                <TextInput source="header" fullWidth />
                <TextInput source="subHeader" fullWidth />
                <TextInput source="step" fullWidth />
                <TextInput source="stepLabel" fullWidth />
                <MarkdownInput source="tooltipLabel" fullWidth />
                <MarkdownInput source="tooltip" fullWidth />
                <TextInput source="screen" fullWidth />
                <BooleanInput source="status" defaultValue={ true }/>
            </SimpleForm>
        </Create>
    )
}